import { render } from "./Copyright.vue?vue&type=template&id=5458773a"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"
script.render = render

export default script